<template>
  <Loading v-if="isLoading" />
  <div class="tit-group02 inner-ty">
    <h2 class="tit">Total: {{ totalCnt }}</h2>
    <div class="filter-btn-group">
      <v-btn class="reset" :class="filterDivClass" @click="onClickInitFilter">{{t('message.filterInit')}}</v-btn>
      <v-btn class="filter" @click="filterOpen" :class="filterDivClass">{{t('message.filter')}}</v-btn>
    </div>
  </div>
  <div class="sort-group ty01" :class="filterDivClass">
    <div class="sort-row">
      <div class="wl">
        <div class="txt-total">Total: {{ totalCnt }}</div>
        <c-inputSearch v-bind="inputSearch" v-model="searchModel" @search-word="onClickSearch" @keyup.enter="onClickSearch"/>
      </div>
    </div>
    <div class="sort-row">
      <div class="wl">
        <div class="txt01">{{t('message.period')}}</div>
        <div class="date-sort">
          <c-InputDate v-model="startDate" :enableTimePicker="false" readonly="" />
          <div class="txt02">~</div>
          <c-InputDate v-model="endDate" :enableTimePicker="false" readonly=""/>
        </div>
        <div class="date-sort">
          <c-btn02 :btnText="t('message.oneWeek')" class="ty01" @click="onClickDate('week')"/>
          <c-btn02 :btnText="t('message.oneMonth')" class="ty01" @click="onClickDate('month')"/>
        </div>
        <Select v-bind="deptSelect" v-model="deptModel" v-if="monitoringType != 1"/>
        <Select v-bind="memberSelect" v-model="memberModel" v-if="monitoringType == 3"/>
      </div>
    </div>
  </div>
  <div class="tbl-group size-custom4">
    <v-data-table
      :headers="headers"
      :items="items"
      :items-per-page-options="footerOptions"
      return-object
    >
      <template v-slot:item.idx="{ item, index }" >
        <div class="ell01">
          {{index+1}}
        </div>
      </template>
      <template v-slot:item.author="{ item }" >
        <div class="ell01">
          {{item.memberName}}
        </div>
        <div class="txt-tag">
          {{item.memberId}}
        </div>
      </template>
      <template v-slot:item.regDateFormat="{ item }" >
        <div class="ell01">
          {{dayjs(item.regDate).format('YYYY-MM-DD HH:mm:ss')}}
        </div>
      </template>
      <template v-slot:item.moData="{ item }" >
        <!--s:모바일용 데이터-->
        <div class="td-mobile">
          {{`${item.monitoringTitle}`}}
        </div>
        <div class="td-mobile n2">
          {{item.memberName}}
          <span>
          {{item.memberId}}
          </span>
        </div>
        <div class="td-mobile n3">
          {{dayjs(item.regDate).format('YYYY-MM-DD HH:mm')}}
        </div>
        <!--e:모바일용 데이터-->
      </template>
      <template v-slot:item.detailView="{ item }">
        <div class="flex-c">
          <BtnIcon class="btn-ico-search" @click="onClickDetail(item.idx, '1')"/>
        </div>
      </template>
    </v-data-table>
  </div>
  <DialogMonitoringDetail
    v-model="monitoringDetailModel"
    @close="monitoringDetailModel=false"/>
</template>

<script setup lang="ts">
import {onMounted, ref, watch} from 'vue';
import BbsService from "@/services/bbs.service";
import CompanyService from "@/services/company.service";
import MemberService from "@/services/member.service";
import utils from "@/common/Utils";
import {useCommonStore} from "@/store/common";
import {storeToRefs} from "pinia";
import _ from 'lodash';
import dayjs from "dayjs";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const props = defineProps(['monitoringType', 'activeTab', 'isActive'])

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)
const route:any = useRoute()

//bind
const isLoading = ref(false)
const snackbar = ref(false)
const snackText = ref('')
let viewIdx = route.params.idx?route.params.idx:storeRef.viewIdx.value
const monitoringDetailModel = ref(false)
const tab = ref('tabCont1')
const filterDivClass = ref('off')
const items = ref([])
const searchModel = ref('')
const totalCnt = ref(0)
const startDate = ref('')
const endDate = ref('')
const deptModel = ref('')
const memberModel = ref('')
const monitoringType = props.monitoringType

//ui
const inputSearch = computed(() =>({
  type: 'text',
  placeholder: t('message.searchMultiPlaceholder'),
}))
const deptSelectAdd = ref([])
const deptSelect =computed(() =>({items: [{name:t('message.department'), value:''}, ...deptSelectAdd.value]} ))
const memberSelectAdd = ref([])
const memberSelect = computed(() =>({items: [{name:t('message.individual'), value:''}, ...memberSelectAdd.value]} ))
const headers = [
  { title: t('message.orderNumber'), key: 'idx' },
  { title: t('message.monitoringName'), key: 'monitoringTitle' },
  { title: t('message.author'), key: 'memberName' },
  { title: t('message.isMonitoring'), key: 'monitoringYn'},
  { title: t('message.isSafetyTalk'), key: 'timelineYn'},
  { title: t('message.createdAt'), key: 'regDateFormat' },
  { title: t('message.monitoringWithAuthorAndDate'), key: 'moData' },
  { title: t('message.viewDetails'), key: 'detailView' },
]
const footerOptions = [
  { value: 5, title: '5' },
  { value: 10, title: '10' },
  { value: 25, title: '25' },
  { value: 50, title: '50' },
  { value: -1, title: '$vuetify.dataFooter.itemsPerPageAll' }
]

//hook
onMounted(() => {
  onClickDate('week')
})

//function
function filterOpen(){
  if(filterDivClass.value == 'off')
    filterDivClass.value = 'on'
  else
    filterDivClass.value = 'off'
}

function onClickDetail(idx, type){
  storeRef.popupIdx.value = idx
  storeRef.popupType.value = type
  storeRef.viewIdx.value = viewIdx
  monitoringDetailModel.value=true
}

function onClickSearch(){
  isLoading.value = true
  const user = JSON.parse(localStorage.getItem('user'))
  const companyIdx = localStorage.getItem('companyIdx')
  let params = {
    keyword: searchModel.value,
    startDate:startDate.value,
    endDate:endDate.value,
    companyIdx: companyIdx?companyIdx:user.companyIdx,
    memberIdx:memberModel.value,
    idx:viewIdx,
    deptIdx:deptModel.value,
    monitoringType:props.monitoringType //모니터링 타입있으면 member,dept{{t('message.filter')}} 무시하고 서버에서 재{{t('message.filter')}}링
  }

  BbsService.getAnswerList(params).then(
    (response) => {
      isLoading.value = false
      items.value = response.result
      totalCnt.value = response.result.length
    },
    (error) => {
      isLoading.value = false
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )

  storeRef.monitoringStartDate.value = startDate.value
  storeRef.monitoringEndDate.value = endDate.value
  storeRef.monitoringDept.value = deptModel.value
}

function onClickDate(type){
  const end = dayjs().format('YYYY-MM-DD')
  let start = dayjs().subtract(7, 'day').format('YYYY-MM-DD')
  if(type == 'month')
    start = dayjs().subtract(1, 'month').format('YYYY-MM-DD')

  startDate.value = start.toString()
  endDate.value = end.toString()
}

const onClickInitFilter=()=>{
  searchModel.value = ''
  startDate.value = ''
  endDate.value = ''
  deptModel.value = ''
  memberModel.value = ''
}

//watch
watch(startDate, (newObj) => {
  if(props.isActive)
    onClickSearch()
})

watch(endDate, (newObj) => {
  if(props.isActive)
    onClickSearch()
})

watch(deptModel, (newObj) => {
  if(props.isActive)
    onClickSearch()
})

watch(memberModel, (newObj) => {
  if(props.isActive)
    onClickSearch()
})

watch(() => props.isActive, (val, oldVal) => {
  if (val) {
    if(viewIdx) {
      //{{t('message.filter')}}정보
      if(!utils.isEmpty(storeRef.monitoringStartDate.value)) startDate.value = storeRef.monitoringStartDate.value
      if(!utils.isEmpty(storeRef.monitoringEndDate.value)) endDate.value = storeRef.monitoringEndDate.value
      if(!utils.isEmpty(storeRef.monitoringDept.value)) deptModel.value = storeRef.monitoringDept.value
      //조직정보
      const companyIdx = localStorage.getItem('companyIdx')
      let params = {idx: 0, companyIdx: companyIdx, treeType: 'dept'}
      CompanyService.getCompanyTreeList(params).then(
        (response) => {
          _.forEach(response.result, function (item){
            deptSelectAdd.value.push({name:item.treeName, value:item.idx})
          })
        },
        (error) => {
          if(error.status == 403)
            utils.movePage('/login')
          else{
            snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
            snackbar.value = true
          }
        }
      )
      //회원정보
      let params2 = {companyIdx: companyIdx}
      MemberService.getMemberListFilter(params2).then(
        (response) => {
          _.forEach(response.result, function (item){
            memberSelectAdd.value.push({name:item.memberName, value:item.idx})
          })
        },
        (error) => {
          if(error.status == 403)
            utils.movePage('/login')
          else{
            snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
            snackbar.value = true
          }
        }
      )

      onClickSearch()
    }
  }
},{ immediate: true })
</script>


<style lang="scss" scoped>
.container.main.on{
  .v-window{}
}
</style>

